export const sequenceMap = {
  INSIDE_CANDLE: '1',
  FAIL_TO_BREAK_HIGH: 'FBH',
  FAIL_TO_BREAK_LOW: 'FBL',
  BREAK_CANDLE: '2',
  BREAK_LOW: '2D',
  BREAK_HIGH: '2U',
  OUTSIDE_CANDLE: '3',
  OUTSIDE_CANDLE_DOWN: '3D',
  OUTSIDE_CANDLE_UP: '3U',
};
